import React from 'react';
import { BUTTON_GHOST, BUTTON_SOLID } from './adminStyles';
interface Props {
  /** ISO date the + was pressed on. */
  date: string;
  onEntry: () => void;
  onShoot: () => void;
  onCancel: () => void;
}

/**
 * Two different things can go on a day now, so the + asks which rather than
 * guessing. A guess would be wrong about half the time, and the wrong one
 * here means a shoot date the client can see.
 */
export function DayAddChooser({
  date,
  onEntry,
  onShoot,
  onCancel
}: Props) {
  const day = new Date(`${date}T00:00:00`).toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long'
  });
  return <div className="mt-10 max-w-xl border border-paper/25 px-6 py-7 sm:px-8" data-id="element-835" data-mp="2mz1sqruh7spn">
      <p className="font-display text-xl leading-snug" data-id="element-836" data-mp="2r03lqqxsv8j6">Add to {day}</p>
      <p className="label-sm mt-3 leading-relaxed text-paper/40" data-id="element-837" data-mp="3eqzg9vtn4hu4">
        A shoot day belongs to a project and drives the client&rsquo;s schedule and the call sheet.
        A diary entry is just for the studio, and goes on the company calendar.
      </p>
      <div className="mt-6 flex flex-wrap items-center gap-5" data-id="element-838" data-mp="2id4r3dwssyx2">
        <button type="button" onClick={onEntry} className={BUTTON_SOLID} data-id="element-839" data-mp="2detif6i8ougf">
          Diary Entry
        </button>
        <button type="button" onClick={onShoot} className={BUTTON_GHOST} data-id="element-840" data-mp="2s3g73ytraykb">
          Shoot Day
        </button>
        <button type="button" onClick={onCancel} className={BUTTON_GHOST} data-id="element-841" data-mp="2nadepu0ptv5p">
          Cancel
        </button>
      </div>
    </div>;
}